import { request } from '@/utils/request';
import * as url from '@/src/constant';

const ROUTE_BANKS = '/pages/banks/index';
/**
 * 获取银行卡列表
 * @param query
 * @returns {Promise<TResult>}
 */
export function fetchCardList(query) {
  return request({
    url: url.QUERY_SUPPORTED_SALARY_ACCOUNTINFO_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_BANKS,
  });
}

/**
 * 设置结算账户
 * @param query
 * @returns {Promise<TResult>}
 */
export function setSalaryAccount(query, header) {
  return request({
    url: url.CHANGE_SALARY_ACCOUNT_URL,
    method: 'POST',
    query,
    header,
    // message问题已修复
    showToast: false,
    returnUrl: ROUTE_BANKS,
  });
}
// 更新当前结算卡的信息
export function refreshSalaryAccount(query) {
  return request({
    url: url.REFRESH_SALARY_ACCOUNT_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_BANKS,
  });
}
